/* eslint-disable no-mixed-spaces-and-tabs */
import { React } from 'react';
import { Box, Stack, Typography, CircularProgress, useTheme } from '@mui/material';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { PageHeader } from '@/components/layouts/PageHeader';
import { SettingsIcon } from '@/components/icons/SettingsIcon';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { SettingsView } from '@/components/views/SettingsView';

export const SettingsPage = () => {
	const theme = useTheme();
	const { getFeatureFlags, isLoading } = useFeatureFlagContext();
	const showProfile = Boolean(getFeatureFlags('profile')?.active);

	return (
		<AuthenticatedPageLayout>
			{showProfile ? (
				<SettingsView />
			) : (
				<Stack>
					<PageHeader
						title={'Profile'}
						icon={
							<SettingsIcon
								{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
							/>
						}
					/>
					<Box px={3}>
						{isLoading ? (
							<CircularProgress />
						) : (
							<Typography>{'Profile coming soon.'}</Typography>
						)}
					</Box>
				</Stack>
			)}
		</AuthenticatedPageLayout>
	);
};
